import React, { Component } from 'react';
import { RadioButtonGroup } from 'components';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import Dropdown from 'react-toolbox/lib/dropdown';
import Input from 'react-toolbox/lib/input';
import styles from './PopupNoSale.css';

let options;
const debug = _debug('app:PopupNoSale');
const radioButtonData = [
  {
    label: 'Yes',
    value: '0'
  }, {
    label: 'No',
    value: '1'
  }
];
const translatedData = [
  { value: 1, label: 'No calificó' },
  { value: 2, label: 'No estaba interesado' },
  { value: 3, label: 'No puede pagar' },
  { value: 4, label: 'Información equivocada' },
  { value: 5, label: 'No fue posible hacer contacto' },
  { value: 6, label: 'Falleció' },
  { value: 7, label: 'Otro' }
];

class PopupNoSale extends Component {
  static propTypes = {
    dataId: React.PropTypes.string,
    picklistReasonCode: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    contactData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    strings: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    fetchContactData: React.PropTypes.func,
    updateContactData: React.PropTypes.func,
    closeModal: React.PropTypes.func,
    refreshTable: React.PropTypes.func,
    currentLanguage: React.PropTypes.string,
    wholeData: React.PropTypes.objectOf(React.PropTypes.shape({})),
  };

  constructor(props) {
    super(props);
    this.state = { commentValue: '', value: '' };
    options = this.props.picklistReasonCode;

    if (this.props.currentLanguage === 'es') {
      // options.forEach((optionValue, index) => {
      //   const currentOption = translatedData.find(
      // currentValue => currentValue.label === optionValue.label);
      //   options[index].label = currentOption.translated;
      // });
      options = translatedData;
    }
  }

  componentWillMount() {
    const promised = this.props.fetchContactData(this.props.dataId);
    promised.then((response) => {
      if (!isNaN(parseInt(response.cica_reasoncode, 10))) {
        this.setState({ value: parseInt(response.cica_reasoncode, 10) });
      } else {
        this.setState({ value: 1 });
      }
      if ((response.cica_reasontext !== '') && (response.cica_reasontext !== null)) {
        this.setState({ radioValue: '1' });
        this.setState({ commentValue: response.cica_reasontext });
      } else {
        this.setState({ radioValue: '0' });
      }
    }, errorResponse => debug(errorResponse));
  }

  updateContactData = () => {
    const contactData = this.props.contactData;
    contactData.cica_reasoncode = this.state.value;
    if (this.state.radioValue === '1') {
      contactData.cica_reasontext = this.state.commentValue;
    }
    contactData.cica_leaddispositionstatus = '5';
    contactData.isappointmentterminated = false;
    if (this.state.value !== 6) {
      if ((contactData.cica_leadtype !== 7 && contactData.cica_leadtype !== '7')) {
        contactData.cica_isactive = 0;
      }
    }
    this.props.updateContactData(contactData).then(() => {
      this.props.refreshTable(true);
    }, errorResponse => debug(errorResponse));
    this.props.closeModal();
  }

  commentAction = (commentValue) => {
    this.setState({ commentValue });
  }
  handleDropdownChange = (value) => {
    this.setState({ value });
  }
  handleRadioChange = (value) => {
    this.setState({ commentValue: '' });
    this.setState({ radioValue: value });
  };
  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.pageDropDown}>
          <Dropdown
            auto
            source={options}
            onChange={this.handleDropdownChange}
            value={this.state.value}
            theme={styles}
          />
        </div>
        { this.state.value === 4 && (this.props.wholeData.leadType === 'Active' || this.props.wholeData.leadType === 'Lapsed') &&
          <div className={styles.questionHolder}>
            <div className={styles.updateQuestion}>
              <span className={styles.radioQuestionLabel}>
                Has an update to the lead information been provided?
              </span>
            </div>
            <div className={styles.radioButtonDiv}>
              <div className={styles.placeholder} />
              <RadioButtonGroup
                name="popupRadioButton"
                value={this.state.radioValue}
                themestyles={styles}
                radioButtonName={'popupRadioButton'}
                radioButtonData={radioButtonData}
                handleRadioChange={this.handleRadioChange}
              />
              <div className={styles.placeholder} />
            </div>
          </div>
        }
        { this.state.radioValue === '1' && this.state.value === 4 && (this.props.wholeData.leadType === 'Active' || this.props.wholeData.leadType === 'Lapsed') &&
          <div className={styles.inputContainerHolder}>
            <div className={styles.inputTextDiv} >
              <span className={styles.labelText}>
                Reason for No update
              </span>
              <Input
                type="text"
                name={'Reason for No update'}
                hint={'Reason for No update'}
                display="flex"
                theme={styles}
                floating={false}
                onChange={this.commentAction}
                value={this.state.commentValue}
              />
            </div>
          </div>
        }
        <div className={styles.saveDiv}>
          <button
            className={styles.saveSpan}
            onMouseDown={() => this.updateContactData()}
          >{strings.save}</button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contactData: state.popup.contactData,
  fetchContactData: state.popup.fetchContactData,
  updateContactData: state.popup.updateContactData,
  picklistReasonCode: state.manage.picklistReasonCode
});
export default connect(mapStateToProps, actions)(PopupNoSale);



// WEBPACK FOOTER //
// ./src/containers/PopupNoSale/PopupNoSale.js